import RouteManagement from "../components/RouteManagement";

const RouteManagementPage = () => {
  return <RouteManagement />;
};

export default RouteManagementPage;
